import { AxiosResponse } from 'axios';
import { IValidationApiResponse } from '../../Services/FormikValidatorService';
import { getRequest, postRequest, putRequest } from '../../Services/HttpService';
import { IOption } from '../Forms/CmdField';
import { IGdprProfileInputForm } from './types';

export interface IAuthItem {
  name: string;
  enabled: boolean;
  can: {
    [item: string]: boolean;
  };
}

export interface IGdprProfileResponse {
  profile?: IGdprProfileDataResponse;
  passed?: boolean;
  errors?: {
    [key: string]: string[];
  };
  status?: number | string;
  toasts?: {
    message: string;
    messagePayload: string | null;
    type: string;
    duration: number;
    verticalPosition: string;
    horizontalPosition: string;
  };
  data?: null | any;
  error: any;
}

export interface IGdprProfileDataResponse {
  createdAt: string;
  createdBy: number;
  customerId: number;
  deletedAt: null;
  deletedBy: number | null;
  description: string;
  id: number;
  modifiedAt: string;
  modifiedBy: number | null;
  name: string;
  authCorrections: IAuthItem[];
  authMap: IAuthItem[];
  authRefuelings: IAuthItem[];
  authReports: IAuthItem[];
  authRides: IAuthItem[];
}

export const getData = async (id: number): Promise<IGdprProfileDataResponse | null> => {
  const url = `/v1/gdpr/profile/${id}`;
  const response: AxiosResponse | false = await getRequest(url, { returnAxiosResponse: true });

  if (response && response.data && response.data.profile) {
    return response.data.profile;
  }
  return null;
};

export const add = async (values: IGdprProfileInputForm): Promise<IGdprProfileResponse | false> => {
  const response = await postRequest<IGdprProfileInputForm, IGdprProfileResponse | false>(
    `/v1/gdpr/profile/add`,
    values,
    {
      returnAxiosResponse: true,
      returnAxiosError: true,
      showErrorToaster: false,
    }
  );
  return response;
};

export const edit = async (
  id: number,
  values: IGdprProfileInputForm
): Promise<IGdprProfileResponse | false> => {
  const response = await putRequest<IGdprProfileInputForm, IGdprProfileResponse | false>(
    `/v1/gdpr/profile/${id}/edit`,
    values
  );

  return response;
};

export const getValidation = async (): Promise<IValidationApiResponse | null> => {
  const url = `/v1/gdpr/profile/validation`;
  const response: AxiosResponse | false = await getRequest(url, { returnAxiosResponse: true });
  if (response && response.data && response.status === 200) {
    const data = response.data;
    if (data.name) {
      const nameRules: IFormRules[] = [];
      Object.values(data.name).forEach((i: any) => {
        if (i.param !== 'assertTrue') {
          nameRules.push(i);
        }
      });
      data.name = nameRules;
    }
    return data;
  }
  return null;
};

export const getCustomers = async (): Promise<IOption[] | null> => {
  const url = `/v1/gdpr/profile/form/customerId`;
  const response: AxiosResponse | false = await getRequest(url, { returnAxiosResponse: true });
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return null;
};
